var styles = {
  "TooltipOverlay": "Polaris-Tooltip-TooltipOverlay",
  "measuring": "Polaris-Tooltip-TooltipOverlay--measuring",
  "positionedAbove": "Polaris-Tooltip-TooltipOverlay--positionedAbove",
  "Content": "Polaris-Tooltip-TooltipOverlay__Content"
};

export { styles as default };
